import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";

export function PendingApprovalPage() {
  const { t } = useTranslation("auth");
  const { user, isAuthenticated, isLoading, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated) {
      navigate("/login", { replace: true });
      return;
    }
    if (user?.isAllowed || user?.isSuperAdmin) {
      navigate("/dashboard", { replace: true });
    }
  }, [isLoading, isAuthenticated, user, navigate]);

  if (isLoading || !user) {
    return null;
  }

  const userInitial = user.name?.charAt(0)?.toUpperCase() ?? "?";

  return (
    <div className="flex h-screen items-center justify-center bg-surface-1">
      <div className="flex flex-col items-center gap-6 max-w-sm text-center px-4">
        <div className="w-16 h-16 rounded-full bg-brand-subtle flex items-center justify-center text-2xl font-semibold text-brand-subtle-text">
          {user.avatarUrl ? (
            <img
              src={user.avatarUrl}
              alt={user.name}
              className="w-full h-full rounded-full object-cover"
            />
          ) : (
            userInitial
          )}
        </div>

        <div className="space-y-2">
          <h1 className="text-xl font-semibold text-foreground">
            {t("pendingApproval.title")}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t("pendingApproval.message", { name: user.name })}
          </p>
          <p className="text-xs text-muted-foreground">{user.email}</p>
        </div>

        <Button
          variant="outline"
          size="sm"
          onClick={() => logout()}
          className="w-full"
        >
          {t("actions.signOut", { ns: "common" })}
        </Button>
      </div>
    </div>
  );
}
